import { render, staticRenderFns } from "./examPoint.vue?vue&type=template&id=16e5c923"
import script from "./examPoint.vue?vue&type=script&lang=js"
export * from "./examPoint.vue?vue&type=script&lang=js"
import style0 from "./examPoint.vue?vue&type=style&index=0&id=16e5c923&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports